import { EntityModifierViewModel, ItemViewModel } from 'store/models/sellModels'
import { ItemType } from 'models'
import { hasData } from 'utilities/arrayHelper'
import { getItemModifiers } from './getModifiers'

export function requireModifyDialogChecker(
    item: ItemViewModel,
    modifierList: EntityModifierViewModel[],
) {
    const hasModifiers = hasData(getItemModifiers(item, modifierList))
    const requireSelectDepositType =
        item.type === ItemType.BaseDepositAndCreditProduct &&
        // There are 2 deposit-and-credit items
        item.depositAndCreditItems.length > 1 &&
        item.depositAndCreditItems.every((dci) => dci.isAvailableForSelection)
    return (
        item.variantGroups.length > 0 ||
        hasModifiers ||
        item?.type === ItemType.Combo ||
        requireSelectDepositType
    )
}
